'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

var index = require('../../external/classnames/index.js');

var PropTypes = require('prop-types');

var useScreenSize = require('../../utilities/hooks/useScreenSize.js');

require('../../blocks/Accordion/Accordion.js');

require('../../blocks/AlertBanner/AlertBanner.js');

require('../../blocks/ArticleList/ArticleList.js');

require('../../blocks/ArticleList/ArticleListItemImage/ArticleListItemImage.js');

var CardCarousel = require('../../blocks/CardCarousel/CardCarousel.js');

require('../../blocks/ContentBody/ContentBody.js');

require('../../blocks/ContentIntroduction/ContentIntroduction.js');

require('../../blocks/ContentTitle/ContentTitle.js');

require('../../blocks/Gallery/Gallery.js');

require('../../blocks/SideBar/SideBar.js');

require('../../blocks/SideBar/ContactsBlock/ContactsBlock.js');

require('../../blocks/SideBar/ListBlock/ListBlock.js');

require('../../blocks/SideBar/ListenBlock/ListenBlock.js');

require('../../blocks/SideBar/MediaContactBlock/MediaContactBlock.js');

require('../../blocks/SideBar/SearchBlock/SearchBlock.js');

require('../../blocks/SideBar/SocialBlock/SocialBlock.js');

require('../../blocks/SideBar/TopicBlock/TopicBlock.js');

require('../../composites/Card/Card.js');

require('../../composites/Card/CardBody/CardBody.js');

require('../../composites/Card/CardImage/CardImage.js');

require('../../composites/Card/CardText/CardText.js');

require('../../composites/Card/CardTitle/CardTitle.js');

require('../../composites/Carousel/Carousel.js');

require('../../composites/Carousel/CarouselControl/CarouselControl.js');

require('../../composites/Carousel/CarouselIndicator/CarouselIndicator.js');

require('../../composites/Carousel/CarouselIndicators/CarouselIndicators.js');

var CarouselItem = require('../../composites/Carousel/CarouselItem/CarouselItem.js');

require('../../composites/Carousel/CarouselInner/CarouselInner.js');

require('../../composites/Modal/Modal.js');

require('../../composites/Modal/ModalBody/ModalBody.js');

require('../../composites/Modal/ModalFooter/ModalFooter.js');

require('../../composites/Modal/ModalHeader/ModalHeader.js');

require('../../composites/SearchBar/SearchBar.js');

require('../../composites/Video/Video.js');

var PodcastCard = require('./PodcastCard/PodcastCard.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var renderPodcastCards = function renderPodcastCards(podcasts, target) {
  return podcasts.slice(0, 3).map(function (_ref, index) {
    var summary = _ref.summary,
        episode_number = _ref.episode_number,
        id = _ref.id,
        date_published = _ref.date_published,
        season = _ref.season;
    _ref.slug;
    var title = _ref.title,
        link = _ref.link,
        podcastName = _ref.podcastName;
    return /*#__PURE__*/React__default['default'].createElement(CarouselItem.CarouselItem, {
      key: "podcast-card-".concat(id, "-").concat(index),
      className: "lanl-card-carousel-item",
      itemId: index,
      card: true
    }, /*#__PURE__*/React__default['default'].createElement(PodcastCard.PodcastCard, {
      key: "podcast-card-".concat(id, "-").concat(index),
      date: date_published,
      description: summary,
      episode: "EP".concat(episode_number),
      link: link,
      podcastName: podcastName,
      season: season,
      target: target,
      title: title
    }));
  });
};

var PodcastCarousel = function PodcastCarousel(_ref2) {
  var className = _ref2.className,
      podcasts = _ref2.podcasts,
      target = _ref2.target;
  var classes = index['default']('podcast-carousel', useScreenSize.useScreenSize() > 1600 && 'hide-podcast-control', className);
  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: classes,
    "data-testid": "lanl-podcast-carousel"
  }, /*#__PURE__*/React__default['default'].createElement("section", {
    className: 'primary-gradient'
  }, /*#__PURE__*/React__default['default'].createElement(CardCarousel.CardCarousel, {
    length: 3,
    className: "video-card-carousel",
    cardSizeLg: 530,
    cardSizeSm: 360,
    controlsColor: 'white'
  }, renderPodcastCards(podcasts, target))));
};

PodcastCarousel.defaultProps = {
  podcasts: [],
  target: ''
};
PodcastCarousel.propTypes = {
  podcasts: PropTypes__default['default'].array.isRequired,
  className: PropTypes__default['default'].string,
  target: PropTypes__default['default'].oneOf(['_blank', '_self', '_parent', '_top', ''])
};
exports.PodcastCarousel = PodcastCarousel;
exports['default'] = PodcastCarousel;